import { Icons, Images } from "assets";
import classNames from "classnames";
import CustomModal from "shared/components/common/customModal";
import styles from "./style.module.scss";
import { ProductType } from "shared/utils/enum";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

interface Props extends ModalProps {
  detail: ProductDetail | null;
}

const ProductDetailsModal = ({ detail, show, handleClose }: Props) => {
  return show ? (
    <CustomModal>
      <div className={classNames(styles.contentContainer)}>
        <div
          className={classNames(
            "flex items-center justify-between px-4 mt-4 mb-3"
          )}
        >
          <h3 className={styles.modalTitle}>Product Details</h3>
          <div
            className={classNames(styles.crossContainer)}
            onClick={() => {
              handleClose();
            }}
          >
            <Icons.Cross />
          </div>
        </div>

        <div
          className={classNames(styles.modalBody, "w-full flex flex-col gap-2")}
        >
          <div
            className={classNames(styles.section, "mb-4 flex flex-col gap-2")}
          >
            <h4>Product</h4>
            <div className="flex items-center justify-center my-2">
              <Swiper
                className={classNames(styles.listingSlider)}
                spaceBetween={0}
                slidesPerView={1}
                loop
                pagination={{ type: "bullets", clickable: true }}
                modules={[Pagination]}
              >
                <div className={classNames(styles.productImgContainer)}>
                  {detail?.media
                    ?.filter((media) => media.type !== "video")
                    ?.map((media, index) => (
                      <SwiperSlide key={index} className="slider-img relative">
                        <img
                          src={media.fullpath}
                          alt=""
                          height={120}
                          width={188}
                        />
                      </SwiperSlide>
                    ))}
                </div>
              </Swiper>
            </div>
            <p className="">
              <strong>Title:</strong> {detail?.title || "N/A"}
            </p>
            <p className="">
              <strong>Type:</strong> {detail?.product_type || "N/A"}
            </p>
            <p className="">
              <strong>Price:</strong>{" "}
              {detail?.product_type === ProductType.ISO
                ? `$${detail?.price} - $${detail?.priceUpto}`
                : `$${detail?.price}` || "N/A"}
            </p>
            <p className="">
              <strong>Status:</strong> {detail?.product_status || "N/A"}
            </p>
            <p className="">
              <strong>Year:</strong> {detail?.year || "N/A"}
            </p>
            <p className="">
              <strong>Make:</strong> {detail?.make || "N/A"}
            </p>
            <p className="">
              <strong>Model:</strong> {detail?.model || "N/A"}
            </p>
            <p className="">
              <strong>Part Number:</strong> {detail?.part_number || "N/A"}
            </p>
            <p className="">
              <strong>Description:</strong> {detail?.desc || "N/A"}
            </p>
            <p className="">
              <strong>Shipping Method:</strong>{" "}
              {detail?.shipping_option || "N/A"}
            </p>
          </div>
          <div
            className={classNames(styles.section, "mb-4 flex flex-col gap-2")}
          >
            <h4>Seller</h4>
            <div className="flex items-center justify-center my-2">
              <div className={classNames(styles.imgContainer)}>
                <img
                  src={
                    detail?.owner?.profile_image?.fullpath
                      ? detail?.owner?.profile_image?.fullpath
                      : Images.DefaultAvatar
                  }
                  alt=""
                />
              </div>
            </div>
            <p className="">
              <strong>Name:</strong> {detail?.owner.name || "N/A"}
            </p>
            <p className="">
              <strong>Type:</strong> {detail?.owner.user_type || "N/A"}
            </p>
          </div>
        </div>
      </div>
    </CustomModal>
  ) : null;
};

export default ProductDetailsModal;
